import React from 'react';

const IssueDetailsContent = ({ issue, onPrint }) => {
  if (!issue) return null;

  return (
    <>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem',
        marginBottom: '1rem',
      }}>
        <div>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Data wydania</div>
          <div style={{ fontWeight: '500' }}>
            {new Date(issue.issue_date).toLocaleString('pl-PL')}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Status</div>
          <div style={{ fontWeight: '500' }}>
            {issue.status === 'completed' ? '✅ Zakończone' : '&#x1F4DD; Szkic'}
          </div>
        </div>
        {issue.customer_name && (
          <div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Odbiorca</div>
            <div style={{ fontWeight: '500' }}>{issue.customer_name}</div>
          </div>
        )}
        {issue.source_document && (
          <div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
              Dokument &#x17A;r&#xF3;d&#x142;owy
            </div>
            <div style={{ fontWeight: '500', color: 'var(--info)' }}>{issue.source_document}</div>
          </div>
        )}
      </div>

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1rem', marginBottom: '1rem' }}>
        <div style={{ fontWeight: '600', marginBottom: '0.5rem', fontSize: '12px' }}>
          Pozycje wydania
        </div>
        <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: 'var(--bg)' }}>
              <th style={{ padding: '0.4rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>
                Produkt
              </th>
              <th style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                Ilo&#x15B;&#x107;
              </th>
              <th style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                Cena
              </th>
              <th style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                Warto&#x15B;&#x107;
              </th>
            </tr>
          </thead>
          <tbody>
            {(issue.items || []).map((item, idx) => (
              <tr key={idx}>
                <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)' }}>
                  {item.product_name || item.product_full_name}
                  {item.reason && (
                    <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                      &#x1F4DD; {item.reason}
                    </div>
                  )}
                </td>
                <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                  {item.quantity} {item.unit || 'szt.'}
                </td>
                <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                  {parseFloat(item.unit_price || 0).toFixed(2)} z&#x142;
                </td>
                <td style={{ padding: '0.4rem', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                  {parseFloat(item.total_price || 0).toFixed(2)} z&#x142;
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ backgroundColor: 'var(--bg)' }}>
              <td colSpan={3} style={{ padding: '0.4rem', textAlign: 'right', fontWeight: '600' }}>
                RAZEM:
              </td>
              <td style={{ padding: '0.4rem', textAlign: 'right', fontWeight: '600' }}>
                {parseFloat(issue.total_amount || 0).toFixed(2)} z&#x142;
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {issue.notes && (
        <div style={{
          backgroundColor: 'var(--warning-light)',
          padding: '0.5rem',
          borderRadius: '4px',
          fontSize: '11px',
        }}>
          <strong>Uwagi:</strong> {issue.notes}
        </div>
      )}

      <div style={{ marginTop: '1rem', textAlign: 'right' }}>
        <button
          onClick={() => onPrint(issue.id)}
          style={{
            padding: '6px 12px',
            fontSize: '12px',
            border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
            cursor: 'pointer',
          }}
        >
          &#x1F5A8;&#xFE0F; Drukuj WZ
        </button>
      </div>
    </>
  );
};

export default IssueDetailsContent;
